<template>
  <VAutocompleteWithValidation
    v-model="innerValue"
    label="Vyhledat uživatele"
    rules="required"
    :items="innerItems"
    item-text="fullName"
    item-value="id"
    :search-input.sync="search"
    :loading="loading"
    :custom-slot="true"
    outlined
    dense
    :clearable="true"
    v-on="$listeners"
  >
    <template slot="item" slot-scope="{ item }">
      <span v-if="contact && item.customer.phone && item.customer.email">
        {{ item.id }} - {{ item.customer.fullName }}, {{ item.customer.phone }},
        {{ item.customer.email }}</span
      >
      <span v-else-if="contact && item.customer.phone">
        {{ item.id }} - {{ item.customer.fullName }}, {{ item.customer.phone }}</span
      >
      <span v-else-if="contact && item.customer.email">
        {{ item.id }} - {{ item.customer.fullName }}, {{ item.customer.email }}</span
      >
      <span v-else> {{ item.id }} - {{ item.customer.fullName }} </span>
    </template>
    <template slot="selection" slot-scope="{ item }">
      <span v-if="contact && item.customer.phone && item.customer.email">
        {{ item.id }} - {{ item.customer.fullName }}, {{ item.phone }}, {{ item.email }}</span
      >
      <span v-else-if="contact && item.customer.phone">
        {{ item.id }} - {{ item.customer.fullName }}, {{ item.phone }}</span
      >
      <span v-else-if="contact && item.customer.email">
        {{ item.id }} - {{ item.customer.fullName }}, {{ item.email }}</span
      >
      <span v-else> {{ item.id }} - {{ item.customer.fullName }} </span>
    </template>
  </VAutocompleteWithValidation>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation'

export default {
  name: 'CustomerUserAutocomplete',
  components: { VAutocompleteWithValidation },
  props: {
    value: {
      type: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      required: false,
      default: () => ['CUSTOMER', 'CUSTOMER_UNCONFIRMED'],
    },
    contact: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    innerValue: '',
    innerItems: [],
    search: '',
    loading: false,
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    innerItems(newVal) {
      this.$emit('items', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
    items(newVal) {
      this.innerItems = newVal
    },
    search(value) {
      if (typeof this.value == 'number') {
        return
      }
      if (!value || !value.length) {
        this.searchUser(value, true)
      } else {
        this.searchUser(value, false)
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
    if (this.items) {
      this.innerValue = this.items
    }
    this.searchUser('', true)
  },
  methods: {
    ...mapActions({
      searchUsers: 'user/searchUsers',
    }),
    searchUser(value, initial) {
      if (this.cancel) {
        this.cancel()
        this.cancel = null
      }
      if (!value && !initial) {
        return
      }
      let query = {}
      if (initial) {
        query['size'] = 25
      } else {
        query['searchTerm'] = value
      }
      const searchParams = {
        filterParams: query,
      }
      this.loading = true
      this.searchUsers({ params: searchParams, roles: this.roles })
        .then((response) => {
          this.innerItems = response.data.items
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
